import React from "react";
import {
  Box,
  Skeleton,
  Grid,
  Card,
  CardContent,
  Paper,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  ArrowBack,
} from "@mui/icons-material";
const ModernLoder = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 2, md: 4 },
        bgcolor: "background.default",
        borderRadius: "20px",
      }}
    >
      {/* Main Categories View Skeleton */}
      <Box>
        {/* Title Skeleton */}
       <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent={{ xs: "center", sm: "center", md: "center" }}
          alignItems={{ xs: "center", sm: "center", md: "center" }}
          gap={{ xs: 2, sm: 3, md: 3, lg: 30 }}
          mb={4}
        >
          <Box display="flex" alignItems={"center"}>
            <Skeleton
              variant="text"
              width={300}
              height={60}
              sx={{ bgcolor: "grey.800" }}
            />
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "center", sm: "center", md: "center" }}
            gap={{ xs: 2, sm: 2, md: 2 }}
          >
            <Skeleton
              variant="rounded"
              width={250}
              height={40}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton
              variant="rounded"
              width={100}
              height={40}
              sx={{ borderRadius: 2 }}
            />
          </Box>
</Box>
        {/* Categories Grid Skeleton */}
        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              key={item}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  width: 290,
                  height: 178,
                  borderRadius: 4,
                  overflow: "hidden",
                  position: "relative",
                  backgroundColor: "black",
                }}
              >
                {/* Background Image Skeleton */}
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height="100%"
                  sx={{ 
                    bgcolor: "grey.800",
                    position: "absolute",
                    top: 0,
                    left: 0
                  }}
                />
                
                {/* Gradient Overlay */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to right, rgba(211, 21, 21, 0.85) 40%, rgba(228, 138, 138, 0.3) 70%, transparent 100%)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    color: "white",
                    px: 4,
                  }}
                >
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={32}
                    sx={{ 
                      bgcolor: "rgba(255,255,255,0.8)",
                      mb: 1
                    }}
                  />
                  <Skeleton
                    variant="text"
                    width="60%"
                    height={28}
                    sx={{ 
                      bgcolor: "rgba(255,255,255,0.6)",
                      mb: 2
                    }}
                  />
                  <Skeleton
                    variant="rounded"
                    width={120}
                    height={36}
                    sx={{ 
                      bgcolor: "white",
                      borderRadius: 10
                    }}
                  />
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

// For the selected category view
export const CategoryDetailsLoader = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 2, md: 4 },
        bgcolor: "background.default",
        borderRadius: "20px",
      }}
    >
      {/* Back Button Skeleton */}
      <Skeleton
        variant="rounded"
        width={100}
        height={40}
        sx={{ 
          mb: 2, 
          borderRadius: "12px",
          bgcolor: "grey.800"
        }}
      />

      {/* Title and Search Section Skeleton */}
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent={{ xs: "center", sm: "center", md: "center" }}
        alignItems={{ xs: "center", sm: "center", md: "center" }}
        gap={{ xs: 2, sm: 3, md: 3, lg: 30 }}
        mb={4}
      >
        <Box display="flex" alignItems={"center"}>
          <Skeleton
            variant="text"
            width={400}
            height={50}
            sx={{ bgcolor: "grey.800" }}
          />
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "center", sm: "center", md: "center" }}
          gap={{ xs: 2, sm: 2, md: 2 }}
        >
          <Skeleton
            variant="rounded"
            width={250}
            height={40}
            sx={{ borderRadius: 2, bgcolor: "grey.800" }}
          />
          <Skeleton
            variant="rounded"
            width={100}
            height={40}
            sx={{ borderRadius: 2, bgcolor: "grey.800" }}
          />
        </Box>
      </Box>

      {/* Products Grid Skeleton - New Design */}
      <Grid container spacing={3} sx={{ justifyContent: "center" }}>
        {[1, 2, 3, 4, 5, 6].map((item) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            key={item}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              sx={{
                width: 290,
                height: 178,
                borderRadius: 4,
                overflow: "hidden",
                position: "relative",
                backgroundColor: "black",
              }}
            >
              {/* Background Image Skeleton */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={{ 
                  bgcolor: "grey.800",
                  position: "absolute",
                  top: 0,
                  left: 0
                }}
              />
              
              {/* Gradient Overlay */}
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(to right, rgba(211, 21, 21, 0.85) 40%, rgba(228, 138, 138, 0.3) 70%, transparent 100%)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  color: "white",
                  px: 4,
                }}
              >
                <Skeleton
                  variant="text"
                  width="80%"
                  height={28}
                  sx={{ 
                    bgcolor: "rgba(255,255,255,0.8)",
                    mb: 1
                  }}
                />
                <Skeleton
                  variant="text"
                  width="60%"
                  height={24}
                  sx={{ 
                    bgcolor: "rgba(255,255,255,0.6)",
                    mb: 2
                  }}
                />
                <Skeleton
                  variant="rounded"
                  width={120}
                  height={36}
                  sx={{ 
                    bgcolor: "white",
                    borderRadius: 10
                  }}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

// For the registration ideas view
export const RegistrationIdeasLoader = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: { xs: 2, md: 4 },
        bgcolor: "background.default",
        borderRadius: "20px",
      }}
    >
      {/* Back Button Skeleton */}
      <Skeleton
        variant="rounded"
        width={100}
        height={40}
        sx={{ 
          mb: 2, 
          borderRadius: "12px",
          bgcolor: "grey.800"
        }}
      />

      {/* Title Skeleton */}
      <Box sx={{ mb: 4, textAlign: "center" }}>
        <Skeleton
          variant="text"
          width="50%"
          height={50}
          sx={{ mx: "auto", bgcolor: "grey.800" }}
        />
      </Box>

      {/* Add Idea Form Skeleton */}
      <Box
        sx={{
          p: 3,
          mb: 4,
          borderRadius: 3,
          background: "rgba(255,255,255,0.05)",
        }}
      >
        <Box display="flex" alignItems="center">
          <Skeleton
            variant="rounded"
            width="80%"
            height={56}
            sx={{ mr: 2, borderRadius: 2, bgcolor: "grey.800" }}
          />
          <Skeleton
            variant="rounded"
            width="20%"
            height={48}
            sx={{ borderRadius: 2, bgcolor: "grey.800" }}
          />
        </Box>
      </Box>

      {/* Ideas Grid Skeleton - Updated Design */}
      <Grid container spacing={3} sx={{ justifyContent: "center" }}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} sm={6} md={4} key={item}>
            <Card
              sx={{
                width: 300,
                height: 200,
                borderRadius: 3,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                background: "linear-gradient(135deg, #f73030ff 0%, #9c1c1cff 100%)",
                color: "white",
              }}
            >
              <Skeleton
                variant="text"
                width="70%"
                height={40}
                sx={{ bgcolor: "rgba(255,255,255,0.8)", mb: 2 }}
              />
              <Skeleton
                variant="text"
                width="90%"
                height={20}
                sx={{ bgcolor: "rgba(255,255,255,0.6)", mb: 3 }}
              />
              <Skeleton
                variant="rounded"
                width={120}
                height={32}
                sx={{ 
                  bgcolor: "rgba(255,255,255,0.3)",
                  borderRadius: 16
                }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export const ProductDetailSkeleton = ({ onBack }) => {
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Button
        startIcon={<ArrowBack />}
        onClick={onBack}
        sx={{
          color: "text.primary",
          mb: 4,
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          border: "1.5px solid",
          transition: "all 0.3s ease",
          borderColor: "#d32f2f",
          "&:hover": {
            backgroundColor: "action.hover",
            transform: "translateX(-4px)",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            borderColor: "#d32f2f",
            "& .MuiSvgIcon-root": {
              transform: "translateX(-2px)",
            },
          },
          "&:active": {
            transform: "translateX(-2px) scale(0.98)",
          },
        }}
      >
        Back to Products
      </Button>

      <Grid container spacing={2}>
        {/* Main Content Column */}
        <Grid item xs={12} md={12}>
          {/* Product Header Card */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 3,
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              {/* Left side - Product name and category */}
              <Box>
                <Skeleton
                  variant="text"
                  width="80%"
                  height={48}
                  sx={{ mb: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={140}
                  height={32}
                  sx={{ borderRadius: 16 }}
                />
              </Box>

              {/* Right side - Status and toggle button */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "flex-start", sm: "center" },
                  gap: 1,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Skeleton
                    variant="circular"
                    width={28}
                    height={28}
                    sx={{ mr: 1.5 }}
                  />
                  <Skeleton variant="text" width={160} height={28} />
                </Box>
                <Skeleton
                  variant="rectangular"
                  width={180}
                  height={42}
                  sx={{ borderRadius: 20 }}
                />
              </Box>
            </Box>
          </Paper>

          {/* City Status Cards */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 3,
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Skeleton variant="text" width={180} height={32} />
              <Skeleton variant="text" width={120} height={24} />
            </Box>
            <Grid container spacing={1}>
              {[1, 2, 3, 4, 5, 6].map((item) => (
                <Grid item xs={6} sm={4} key={item}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 1.5,
                      borderRadius: "8px",
                      border: "1px solid",
                      borderColor: "divider",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Skeleton variant="text" width={100} height={24} />
                      <Skeleton variant="circular" width={28} height={28} />
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Deliverables Section */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 3,
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Skeleton variant="text" width={160} height={32} />
              <Skeleton variant="circular" width={28} height={28} />
            </Box>
            <List dense>
              {[1, 2, 3].map((item) => (
                <ListItem key={item} sx={{ px: 0, py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: "36px" }}>
                    <Skeleton variant="circular" width={24} height={24} />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Skeleton variant="text" width="90%" height={24} />
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Paper>

          {/* Requirements Section */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 3,
              borderRadius: "12px",
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Skeleton variant="text" width={200} height={32} />
              <Skeleton variant="circular" width={28} height={28} />
            </Box>
            <List dense>
              {[1, 2, 3].map((item) => (
                <ListItem key={item} sx={{ px: 0, py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: "36px" }}>
                    <Skeleton variant="circular" width={24} height={24} />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Skeleton variant="text" width="85%" height={24} />
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Paper>

          {/* Sidebar Content */}
          <Box sx={{ position: "sticky", top: "16px" }}>
            {/* Pricing Section */}
            <Paper
              elevation={0}
              sx={{
                mb: 2,
                p: 3,
                borderRadius: "12px",
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Skeleton variant="text" width={160} height={32} />
                <Skeleton variant="circular" width={28} height={28} />
              </Box>
              <Grid container spacing={2}>
                {[1, 2, 3].map((item) => (
                  <Grid item xs={12} key={item}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        borderRadius: "8px",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Skeleton
                            variant="circular"
                            width={32}
                            height={32}
                            sx={{ mr: 2 }}
                          />
                          <Skeleton variant="text" width={120} height={28} />
                        </Box>
                        <Skeleton variant="text" width={100} height={32} />
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Paper>

            {/* Materials List */}
            <Paper
              elevation={0}
              sx={{
                mb: 2,
                p: 3,
                borderRadius: "12px",
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Skeleton variant="text" width={180} height={32} />
                <Skeleton variant="circular" width={28} height={28} />
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {[1, 2, 3, 4].map((item) => (
                  <Skeleton
                    key={item}
                    variant="rectangular"
                    width={140}
                    height={40}
                    sx={{ borderRadius: 20 }}
                  />
                ))}
              </Box>
            </Paper>

            {/* Video Demo */}
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: "12px",
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Skeleton
                  variant="circular"
                  width={32}
                  height={32}
                  sx={{ mr: 2 }}
                />
                <Skeleton variant="text" width={200} height={32} />
              </Box>
              <Skeleton variant="text" width="90%" height={24} sx={{ mb: 3 }} />
              <Skeleton
                variant="rectangular"
                width="100%"
                height={48}
                sx={{ borderRadius: 8 }}
              />
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};
export const UsersListSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const istab = useMediaQuery(theme.breakpoints.down("md"));
  const isSmall = useMediaQuery(theme.breakpoints.down("xs"));

  // Number of skeleton rows to show
  const skeletonCount = 6;

  if (isMobile || istab || isSmall) {
    // Mobile skeleton view
    return (
      <Box sx={{ p: 1 }}>
        {/* Header skeleton */}
        <Box
          display="flex"
          justifyContent="space-between"
          mb={3}
          flexDirection={isMobile ? "column" : "row"}
          gap={isMobile ? 2 : 0}
          alignItems={isMobile ? "center" : "center"}
        >
          <Skeleton variant="text" width={150} height={40} />
          <Box
            display="flex"
            alignItems="center"
            textAlign="center"
            flexDirection={isMobile ? "column" : "row"}
            width={isMobile ? "100%" : "auto"}
          >
            <Skeleton variant="rounded" width={200} height={40} />
            <Skeleton variant="rounded" width={80} height={40} />
          </Box>
        </Box>

        {/* Mobile card skeletons */}
        {Array.from({ length: skeletonCount }).map((_, index) => (
          <Paper key={index} sx={{ mb: 2, p: 2, borderRadius: 2 }}>
            <Box display="flex" alignItems="center" mb={2}>
              <Skeleton
                variant="circular"
                width={48}
                height={48}
                sx={{ mr: 2 }}
              />
              <Box>
                <Skeleton variant="text" width={120} height={24} />
                <Skeleton variant="text" width={180} height={20} />
              </Box>
            </Box>

            <Box display="flex" justifyContent="space-between" mb={1}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>

            <Box display="flex" justifyContent="space-between" mb={1}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>

            <Box display="flex" justifyContent="space-between" mb={1}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton variant="text" width={100} height={20} />
            </Box>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Box display="flex" alignItems="center">
                <Skeleton variant="rounded" width={40} height={20} />
                <Skeleton
                  variant="rounded"
                  width={60}
                  height={24}
                  sx={{ ml: 1 }}
                />
              </Box>
            </Box>
          </Paper>
        ))}
      </Box>
    );
  }

  // Desktop skeleton view
  return (
    <Box sx={{ p: 3 }}>
      {/* Header skeleton */}
      <Box display="flex" justifyContent="space-between" mb={3}>
        <Skeleton variant="text" width={200} height={50} />
        <Box display="flex" gap={2}>
          <Skeleton variant="rounded" width={300} height={40} />
          <Skeleton variant="rounded" width={100} height={40} />
        </Box>
      </Box>

      {/* Table skeleton */}
      <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead sx={{ bgcolor: "grey.200" }}>
            <TableRow>
              {["User Name", "Mobile", "City", "Email", "Date", "Status"].map(
                (header) => (
                  <TableCell key={header}>
                    <Skeleton variant="text" height={30} />
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.from({ length: skeletonCount }).map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Skeleton
                      variant="circular"
                      width={36}
                      height={36}
                      sx={{ mr: 2 }}
                    />
                    <Skeleton variant="text" width={120} height={24} />
                  </Box>
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={80} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="rounded" width={80} height={24} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" width={180} height={20} />
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Skeleton
                      variant="circular"
                      width={16}
                      height={16}
                      sx={{ mr: 1 }}
                    />
                    <Skeleton variant="text" width={100} height={20} />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    <Skeleton variant="rounded" width={40} height={20} />
                    <Skeleton
                      variant="rounded"
                      width={60}
                      height={24}
                      sx={{ ml: 1 }}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export const ProductCategoriesLoader = ModernLoder;
export default ModernLoder;
